import React from "react";
import { Button } from "react-bootstrap";
import ButtonLoading from "../loading/ButtonLoading";
import PropTypes from "prop-types";

export default function ModalButton(props) {
  let style = {
    float: "right",
    height: "40px",
    marginLeft: "5px",
    width: "100px",
    ...props.style
  };

  return props.clicked ? (
    <Button
      disabled
      onClick={props.onClick}
      style={style}
      variant={props.variant ? props.variant : "secondary"}
    >
      {props.isSubmit ? <ButtonLoading api={props.api || ""} /> : props.children}
    </Button>
  ) : (
    <Button
      onClick={props.onClick}
      style={style}
      variant={props.variant ? props.variant : "secondary"}
    >
      {props.children}
    </Button>
  );
}

ModalButton.propTypes = {
  api: PropTypes.string,
  clicked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  variant: PropTypes.string
};
